<template>
  <div
    class="py-10 lg:py-20 px-4"
    :data-testid="dataTestid"
  >
    <div class="max-w-wrapper-lg mx-auto">
      <Component
        :is="headerTag"
        v-if="$slots.header || title"
        class="text-2xl/[150%] md:text-4xl/[120%] text-center mb-6 md:mb-10 text-semantic-surface-on-surface font-semibold"
        :class="headerTitleClass"
      >
        <slot name="header">
          <!-- eslint-disable vue/no-v-html -->
          <p v-if="title" v-html="title" />
        </slot>
      </Component>

      <div
        class="grid gap-4 md:gap-8"
        :class="contentRows"
      >
        <V2MoleculesCardFeatureCard
          v-for="(item, itemKey) in items"
          :key="itemKey"
          :title="item.title"
          :description="item.desc"
          :header-icon="item.icon"
          :icon-props="item.iconProps"
          class="w-full !max-w-full"
          has-cta
          cta-btn-label="Learn more"
          :cta-btn-to="item.url"
          :cta-btn-target="ctaBtnTarget"
        />
      </div>

      <div
        v-if="$slots.footer"
        class="text-gray-80 mt-4 md:mt-10"
        :class="footerClass"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismHomeSiteLinks'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: ''
  },

  title: {
    type: String,
    default: ''
  },

  items: {
    type: Array,
    default: () => []
  },

  /**
   * a flag that determines if this
   * component is being used inside contentful posts
   */
  inGuides: {
    type: Boolean,
    default: false
  },

  itemsPerRow: {
    type: [Number, String],
    default: 3
  },

  titleClass: {
    type: String,
    default: ''
  },

  headerTag: {
    type: String,
    default: 'p',
    validator: value =>
      ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div'].includes(value)
  },

  headerTitleClass: {
    type: String,
    default: ''
  },

  descriptionClass: {
    type: String,
    default: ''
  },

  footerClass: {
    type: String,
    default: ''
  },

  ctaBtnTarget: {
    type: String,
    default: ''
  }
})

const contentRows = computed(() => {
  if (props.inGuides) {
    return 'md:grid-cols-2'
  }

  return `md:grid-cols-${props.itemsPerRow} grid-cols-1`
})
</script>
